<script lang="ts">
    import { Form, Input } from "sveltestrap";
    import { Searchhere } from "../../utils/Constant/Constant";
    import {searchValue,searchResult,searchIcon,searchToggle,isSearchVisible} from "../../store"
    import {MENUITEMS} from "../../Data/Layout/Sidebar"
    import ListOfMenu from "./ListOfMenu.svelte";
    import EmptyMessage from "./EmptyMessage.svelte";
    let open:boolean = false
    let setSearchValue:string
    searchValue.subscribe((value) => {
        setSearchValue = value;
    });
    let setsearchToggle:boolean;
    searchToggle.subscribe((value) => {
        setsearchToggle = value;
    });
    let setSearchResult:any;
    searchResult.subscribe((value) => {
        setSearchResult = value;
    });
    const checkSearchResultEmpty = (items) => {
      if (!items.length) {
        searchIcon.update( value => value = true);
      } else {
        searchIcon.update( value => value = false);
      }
    };

    const addFix = () => {
      searchToggle.update(value => value = true)
    };

    const removeFix = () => {
      searchValue.update(value => value = "");
      searchToggle.update(value => value = false)
      isSearchVisible.update(value => value = false)
    };
    const handleSearchKeyword=(keyword) => {
      keyword ? addFix() : removeFix()
      let array = []
      searchValue.update(value => value = keyword)
      MENUITEMS.filter((mItems)=>{
        if (mItems.title.toLowerCase().includes(keyword) &&
          mItems.type === "link" ){
            array.push(mItems);
          }
          if (!mItems.menu) return false;
            mItems.menu.filter((subItems) => {  
              if (
                subItems.title.toLowerCase().includes(keyword) &&
                subItems.type === "link"
              ) {
                subItems.icon 
                array.push(subItems);
              }
              if (!subItems.menu) return false;
                subItems.menu.filter((subMenu) => {
                if (subMenu.title.toLowerCase().includes(keyword)) {
                  subMenu.icon = subItems.icon;
                  array.push(subMenu);
                }
                  if (!subMenu.menu) return false;
                  subMenu.menu.filter((lastItems)=>{
                    if(lastItems.title.toLowerCase().includes(keyword)){
                      lastItems.icon = subItems.icon;
                      array.push(lastItems)
                    }
                    return lastItems;
                  })
              });
            return subItems;
          });
          checkSearchResultEmpty(array);
          searchResult.update(value => value = [...array]);
          return mItems;
        });
      }
</script>

<div class="left-menu-header col">
    <ul>
        <li class="position-relative">
            <Form class="form-inline search-form">
                <div class="search-bg">
                    <Input
                        class="form-control-plaintext searchIcon {open ? "open" : ""}"
                        placeholder={Searchhere}
                        on:input={(e) => handleSearchKeyword(e.target.value)}
                    />
                </div>
                <ListOfMenu searchBar={true} />
                <EmptyMessage search={true} />
            </Form>
            <span class="mobile-search search-bg">
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <i class="fa fa-search"  on:click={()=> open = !open}/>
            </span>
        </li>
    </ul>
</div>


